import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  fetchUnassignedItemsForInvoice as fetchUnassignedItemsAPI,
  UnassignedItemsApiResponse,
} from '@/api/v2/unassignedItemsForInvoice';

// Thunk to fetch the job's phase-less line items for the invoice picker
export const fetchUnassignedItemsForInvoice = createAsyncThunk<
  UnassignedItemsApiResponse,
  string,
  { rejectValue: string }
>(
  'v2/unassignedItems/fetchUnassignedItemsForInvoice',
  async (jobId: string, { rejectWithValue }) => {
    try {
      const response = await fetchUnassignedItemsAPI(jobId);
      return response;
    } catch (error) {
      return rejectWithValue(
        error instanceof Error
          ? error.message
          : 'Failed to fetch unassigned items',
      );
    }
  },
);
